import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../data';

export default function Hero() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 120;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative w-full text-white overflow-visible px-4 sm:px-6 lg:px-8 z-10">
      {/* Background Image with Dark Overlay */}
      <div 
        className="absolute top-0 left-0 right-0 bottom-24 sm:bottom-28 lg:bottom-32 bg-cover bg-center bg-no-repeat z-0"
        style={{ 
          backgroundImage: `url('https://assets.auxodev.dk/assets/154be17d-5a98-49b2-8816-0581c018ef0c/a538baf3-356c-4743-8afa-7dbac7b0b0d8.webp')`,
        }}
      />
      <div className="absolute top-0 left-0 right-0 bottom-24 sm:bottom-28 lg:bottom-32 bg-gradient-to-r from-sky-950/95 via-blue-950/85 to-slate-900/65 z-0" />

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto pt-40 sm:pt-72 md:pt-80 lg:pt-80 pb-36 sm:pb-44 md:pb-48 flex flex-col items-start text-left">
        <span className="text-white font-bold uppercase tracking-widest text-sm sm:text-base mb-3 animate-pulse">
          Velkommen hos Peter Sloth
        </span>
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight uppercase leading-none max-w-4xl">
          Entreprenør i <span className="text-white">Brædstrup</span>
        </h1>
        <p className="mt-4 text-base sm:text-lg md:text-xl text-slate-300 max-w-lg font-medium leading-normal">
          Vi kører i Horsens, Silkeborg, Skanderborg og resten af landet for den rette opgave.
        </p>
        
        {/* CTA Buttons */}
        <div className="mt-10 flex flex-wrap gap-4">
          <button
            onClick={() => scrollToSection('om')}
            className="border-2 border-white text-white hover:bg-white hover:text-slate-950 font-bold uppercase text-sm tracking-wider py-3.5 px-8 transition-all duration-200 rounded-none cursor-pointer"
          >
            Læs mere
          </button>
          <button
            onClick={() => scrollToSection('kontakt')}
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold uppercase text-sm tracking-wider py-4 px-8 transition-all duration-200 rounded-none shadow-lg hover:shadow-orange-500/20 cursor-pointer"
          >
            Kontakt os
          </button>
        </div>
      </div>

      {/* Overlapping Category Cards */}
      <div id="ydelser" className="relative z-20 max-w-7xl mx-auto -mb-24 sm:-mb-28 lg:-mb-32">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6 gap-4">
          {services.map((service) => (
            <Link
              key={service.id}
              to={`/ydelser/${service.id}`}
              className="group relative h-40 sm:h-48 bg-white/40 hover:bg-white/60 backdrop-blur-md overflow-hidden cursor-pointer border border-white/20 shadow-xl hover:border-orange-500 transition-all duration-300 block"
            >
              {/* Grayscale Background Image */}
              <div
                className="absolute inset-0 bg-cover bg-center filter grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-500 opacity-20 group-hover:opacity-40"
                style={{ backgroundImage: `url('${service.image}')` }}
              />
              {/* Light overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-white/50 via-transparent to-transparent opacity-80 group-hover:opacity-40 transition-opacity" />

              {/* Card Content */}
              <div className="absolute inset-0 p-4 flex flex-col justify-end items-center text-center">
                <h3 className="text-sm sm:text-base font-extrabold uppercase tracking-wider text-slate-950 group-hover:text-orange-600 transition-colors">
                  {service.title}
                </h3>
                <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-orange-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex items-center gap-1">
                  Læs mere <ArrowRight className="w-3 h-3" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
